
import { Consumer } from '../types';
import { allEnergyConsumers } from '@/data/energy-consumers-data';
import { allWaterConsumers } from '@/data/water-consumers-data';
import { convertToConsumer } from './converters';

/**
 * Generate consumers with better distribution
 */
export const getConsumers = (): Consumer[] => {
  const energyConsumers = allEnergyConsumers.slice(0, 25).map((consumer, index) => 
    convertToConsumer(consumer, index));
  
  const waterConsumers = allWaterConsumers.slice(0, 25).map((consumer, index) => 
    convertToConsumer(consumer, index + 25));
  
  return [...energyConsumers, ...waterConsumers];
};
